<template>
  <div class="goods-category">
    <div class="text-2xl font-bold mb-6">Master Data Goods Category</div>
    <div class="border shadow-lg rounded-md bg-white">
      <div class="p-6 flex justify-between">
        <div class="flex items-center gap-4">
          <div class="w-60">
            <TextField type="text" v-model="keyword" :action="doSearch" placeholder="Masukan kata kunci" />
          </div>
          <div class="">
            <Button buttonText="Cari" @action="doSearch()" />
          </div>
        </div>
        <div class="">
          <LinkButton buttonText="Tambah Kategori Barang" :url="{ name: 'Create Order' }" linkType="internal" />
        </div>
      </div>
      <TableComponent>
        <template v-slot:header>
          <td class="w-16 text-center">No.</td>
          <td class="w-96">Nama</td>
          <td>Kode</td>
          <td class="text-right">Opsi</td>
        </template>
        <template v-slot:body>
          <template v-if="filteredData && filteredData.length > 0">
            <tr v-for="(item, index) in filteredData" :key="item.code + index">
              <td class="w-16 text-center">{{ index + 1 }}</td>
              <td class="w-96">{{ item.name }}</td>
              <td>{{ item.code }}</td>
              <td class="text-right leading-0">
                <span class="inline-block py-1 px-2 border cursor-pointer border-system-error rounded-md hover:bg-neutral-300">
                  <Trash color="system-error" />
                </span>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="5" class="text-center">
                <div class="py-6">Tidak ada data yang tersedia untuk kata kunci yang Anda masukan.</div>
              </td>
            </tr>
          </template>
        </template>
      </TableComponent>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button'),
    Trash: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Trash'),
    LinkButton: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/LinkButton')
  },
  data: () => ({
    searchTerm: '',
    keyword: ''
  }),
  computed: {
    ...mapGetters('master', ['goodsCategories']),
    filteredData() {
      let temp = this.goodsCategories
      if (this.searchTerm !== '' && this.searchTerm) {
        temp = temp.filter(item => {
          return item.name
            .toString()
            .toUpperCase()
            .includes(this.searchTerm.toUpperCase())
        })
      }
      return temp
    }
  },
  methods: {
    ...mapActions('master', ['getGoodsCategories']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    getGoodsCategoryList() {
      this.getGoodsCategories()
        .then(() => {
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    doSearch() {
      this.searchTerm = this.keyword
    }
  },
  created() {
    this.getGoodsCategoryList()
  }
}
</script>
